import { CourseService } from '@/courses/services/courses.service';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';

@Component({
  components: {
  }
})
export default class EdFolderItemProgressComponent extends Vue {
  
  @Prop() readonly section: any;
  @Prop() readonly color: any;

  showProgress: boolean = false;
  showProgressError: boolean = false;
  percentage: number = 0;
  logs: string = 'Waiting...';
  loading: boolean = true;
  hasError = false;
  since = 0;
  limit = 200;
  size = 200;
  componentDestroyed = false;
  totalAccount: number = 0;

  get classId(): number {
    return this.section.classId;
  }

  get courseID(): number {
    return this.section.courseId;
  }

  uploadProgessItemByStatus(sectionStatus) {
    if(sectionStatus && sectionStatus === 'PROCESSING') {
      this.showProgress = true;
      this.getLogs(this.section.id);
    } else if(sectionStatus && sectionStatus === 'ERROR') {
      this.showProgressError = true;
    }
  }

  async getLogs(sectionId: number = null) {

    const {
      log,
      currentLength,
      currentEnd
    }  = await CourseService.getLogsFromUploadZip(sectionId, this.since, this.limit);

    const isStart = log?.includes('<START>');

    if (isStart) {
      this.logs = '';
    }
    
    if (currentLength) {
      this.logs = this.logs + log;

      const isEnd = this.logs.includes('<END>');
      const isError = this.logs.includes('<ERROR>');

      const lines = this.logs.split('\n');
      
      if(this.totalAccount == 0 && this.logs.includes('FILES_ACCOUNT')) {
        const accountValue = lines.find(text => text.includes('FILES_ACCOUNT'));
        this.totalAccount = Number(accountValue.split(':')[1]);
      }

      if (this.totalAccount > 0 && this.logs.includes('UPLOADING_FILE_NUMBER')) {
        const fileLines = lines.filter(l => l.includes('UPLOADING_FILE_NUMBER'));
        const lastLine = fileLines[fileLines.length - 1];
               
        if (lastLine) {
          const number = Number(lastLine.split(':')[1]);
          if (!isNaN(number) && number <= this.totalAccount) {
            this.percentage = Math.max(this.percentage, Math.round((number / this.totalAccount) * 95));
          }
        }
      }
  
      if (isEnd) {
        this.percentage = 100;
        
        await this.$Courses.Store.refreshSectionStructureA({
          sectionId: this.section.sectionId,
          courseId: this.courseID,
          classId: this.classId});

        this.showProgress = false;
        this.componentDestroyed = true;
        return;
      }
  
      if (isError) {
        this.showProgressError = true;
        this.showProgress = false;
        this.componentDestroyed = true;
        return;
      }
  

      if(!this.limit && !isEnd) {
        await this.delay(1000);
        this.getLogs(sectionId);
        return;
      }
      
      if (currentEnd < Number(this.limit)) {
        this.since = currentEnd + 1;
      } else {
        this.since += this.size;
      }
      
      const newLimit = this.since + this.size;
      this.limit = newLimit >= currentLength ? null : newLimit;
      
    } else {
      await this.delay(1000);
    }

    if (!this.componentDestroyed) {
      this.getLogs(sectionId);
    }
  }

  async delay(time: number): Promise<void> {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve();
      }, time);
    });
  } 

  beforeDestroy() {
    this.componentDestroyed = true;
  }

  mounted() {
    this.uploadProgessItemByStatus(this.section.sectionStatus);
  }

  @Watch('section.sectionStatus')
  updateSectionStatus(sectionStatus) {
    this.uploadProgessItemByStatus(sectionStatus);
  }
}

